var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApps(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bounding_box",
    "data-name": "Bounding box"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_Transparent_Rectangle_",
    "data-name": " Transparent Rectangle ",
    width: 24,
    height: 24,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.5,4A1.5,1.5,0,1,1,4,2.5,1.5,1.5,0,0,1,5.5,4ZM20,5.5A1.5,1.5,0,1,0,18.5,4,1.5,1.5,0,0,0,20,5.5Zm-8-3A1.5,1.5,0,1,0,13.5,4,1.5,1.5,0,0,0,12,2.5Zm-8,16A1.5,1.5,0,1,0,5.5,20,1.5,1.5,0,0,0,4,18.5Zm16,0A1.5,1.5,0,1,0,21.5,20,1.5,1.5,0,0,0,20,18.5Zm-8,0A1.5,1.5,0,1,0,13.5,20,1.5,1.5,0,0,0,12,18.5Zm-8-8A1.5,1.5,0,1,0,5.5,12,1.5,1.5,0,0,0,4,10.5Zm16,0A1.5,1.5,0,1,0,21.5,12,1.5,1.5,0,0,0,20,10.5Zm-8,0A1.5,1.5,0,1,0,13.5,12,1.5,1.5,0,0,0,12,10.5Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApps);
export default __webpack_public_path__ + "static/media/Apps.6cf83f86.svg";
export { ForwardRef as ReactComponent };